import gsap from 'gsap'
import { gsapBreakpoints } from 'helpers/breakpoints'
import ScrollTrigger from 'gsap/ScrollTrigger'
import { throttle } from 'throttle-debounce-ts'

const hero = {
  el: {
    image: document.querySelector<HTMLElement>('.hero__image'),
    root: document.querySelector<HTMLElement>('.hero'),
    svgContainer: document.querySelector<HTMLElement>('.hero__image svg > g'),
    svgGroups: document.querySelectorAll<HTMLElement>('.hero__image svg > g > g'),
  },

  init(): void {
    gsap.registerPlugin(ScrollTrigger)

    this.animateOnLoad()
    this.animateOnScroll()
    window.addEventListener('mousemove', throttle(30, this.animateOnMouseMove.bind(this)))
  },

  animateOnLoad(): void {
    const durations = [1.9, 1.765, 2.4, 2.1]
    const rotations = [170, 180, 120, -100]

    gsap
      .timeline()
      .fromTo(
        this.el.image,
        {
          scale: 2,
        },
        {
          clearProps: 'all',
          duration: 1.765,
          ease: 'power3.out',
          rotation: 0,
          scale: 1,
        },
        0
      )
      .fromTo(
        this.el.svgGroups,
        {
          rotation: (index) => rotations[index] * 0.7,
          transformOrigin: '50% 50%',
        },
        {
          clearProps: 'all',
          duration: (index) => durations[index],
          ease: 'power3.out',
          rotation: 0,
        },
        0
      )
  },

  animateOnMouseMove(event): void {
    const rotationModifier = [0.3, 0.9, 0.7, 0.4]
    const x = event.touches ? event.touches[0].clientX : event.clientX
    const xPercent = (x / window.innerWidth - 0.5) * 100
    const y = event.touches ? event.touches[0].clientY : event.clientY
    const yPercent = (y / window.innerHeight - 0.5) * 100

    this.el.svgGroups.forEach((group, index) => {
      gsap.to(group.firstElementChild, {
        duration: 1,
        ease: 'power3.out',
        rotation: xPercent * 0.05 * rotationModifier[index] + yPercent * 0.05 * rotationModifier[index],
        transformOrigin: '50% 50%',
      })
    })
  },

  animateOnScroll(): void {
    gsap.matchMedia().add(gsapBreakpoints, (context) => {
      const is = context.conditions

      ScrollTrigger.create({
        animation: gsap.to(this.el.svgContainer, {
          ease: 'none',
          rotation: is.mobile ? 6 : 12,
          scale: is.mobile ? 1.2 : 1,
          transformOrigin: '50% 50%',
        }),
        end: '100% 0%',
        endTrigger: this.el.root,
        scrub: true,
        start: '0% 0%',
        trigger: 'body',
      })
    })
  },
}

export default hero
